export function constrainedPosition(position, floor, ceiling) {
  if (position < floor) return floor
  else if (position > ceiling) return ceiling
  else return position
}

export default function constrainedImageSize({ width, height, conventional, clip, backgroundSize: { backgroundSizeX, backgroundSizeY },
  backgroundPosition: { backgroundPositionX, backgroundPositionY }, horizontalAngleOfView }) {
  if (horizontalAngleOfView > 180) return { backgroundPositionX: 0, backgroundPositionY: 0 }
  return {
    backgroundPositionX: conventional
      ? constrainedPosition(backgroundPositionX, width - backgroundSizeX, 0)
      : constrainedPosition(backgroundPositionX, height - backgroundSizeX - clip, clip),
    backgroundPositionY: conventional
      ? constrainedPosition(backgroundPositionY, height - backgroundSizeY - clip, clip)
      : constrainedPosition(backgroundPositionY, width - backgroundSizeY, 0)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/fovPreview/constrainedImageSize.js